import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class URLGuard implements CanActivate {

  constructor(
    private router: Router
  ) { }

  canActivate() {
    if (!sessionStorage.getItem('info')) {
      return this.router.createUrlTree(['/']);
    }
    return true;
  }

}
